export const HOME_APP_COUNTRIES = ['se', 'fi'];
export const USERS_APP_COUNTRIES = ['se', 'fi'];
export const LAND_SURVEYS_APP_COUNTRIES = ['se', 'fi'];
export const ROLLOUT_PROGRESS_APP_COUNTRIES = ['se', 'fi'];
//remove later
export const LAND_AGREEMENTS_APP_COUNTRIES = ['se'];
export const LAND_AGREEMENTS_APP_COUNTRIES_V2 = ['se', 'fi'];
export const CHANGE_ORDER_REQUEST_APP_COUNTRIES = ['se'];
export const NETWORK_IMPORT_APP_COUNTRIES = ['se', 'fi'];
export const DELIVERY_PROJECTS_APP_COUNTRIES = ['se'];
export const INSTALLATION_REPORTING_APP_COUNTRIES = ['se', 'fi'];
export const DELIVERY_OVERVIEW_APP_COUNTRIES = ['se', 'fi'];
export const CONSTRUCTION_DOCUMENTS_APP_COUNTRIES = ['se', 'fi'];
export const SPAN_PROTECTION_APP_COUNTRIES = ['se', 'fi'];
